import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=b80e8a6c&scoped=true&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=b80e8a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80e8a6c",
  null
  
)

export default component.exports